import { useMutation } from '@tanstack/react-query';
import { useApi } from 'app/shared/contexts/api';
import { apiRequest, HttpMethod } from '@hqo/shared-modules/dist/api-request';
import { useBuilding } from 'app/shared/contexts/building';

export enum UPDATE_EVENT_POST_TYPE {
  ATTEND = 'attend',
  RECALL = 'recall',
}

interface UpdateEventPostMutation {
  type: UPDATE_EVENT_POST_TYPE;
  uuid: string | undefined;
}

export const useUpdateEventPostMutation = () => {
  const { building } = useBuilding();
  const { apiUrl, getAuthHeaders } = useApi() as unknown as {
    apiUrl: string;
    getAuthHeaders: () => Promise<{ Authorization: string }>;
  };

  return useMutation({
    mutationFn: async ({ type, uuid }: UpdateEventPostMutation) => {
      const headers = await getAuthHeaders();
      const apiPath = type === UPDATE_EVENT_POST_TYPE.ATTEND
        ? `${'/api/tenant/v1/buildings'}/${building?.uuid}${'/event-posts'}/${uuid}${'/attend'}`
        : `${'/api/tenant/v1/event-posts'}/${uuid}${'/recall'}`;

      const response = await apiRequest<unknown, void, void>({
        url: `${apiUrl}${apiPath}`,
        method: HttpMethod.PUT,
        headers: { ...headers,
          'HqO-Building-UUID': building?.uuid ?? '',
        },
      });

      return response.isEmpty() ? null : response.data;
    },
  });
};
